<template>
  <el-select
    :value="selected"
    @input="dispatch"
    :placeholder="plc || $t(`message.patient_indicators`)"
    filterable
    clearable
 
  >
    <el-option v-for="item in patientIndicatorNames" :key="item.id" :label="item.name" :value="item.id"></el-option>
  </el-select>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import inventory from '@/utils/mixins/components/inventory';

export default {
  mixins: [inventory],
  props: ['patient_indicator_name_id'],
  mounted() {
    if (this.patientIndicatorNames && this.patientIndicatorNames.length === 0) {
      this.getInventory();
    }
  },
  watch: {
    patient_indicator_name_id:{
       handler: function (val, oldVal) { 
          this.selected = val;
          this.$emit("input", this.selected);
       },
       deep: true,
       immediate: true
    }
  },
  computed: {
    ...mapGetters({
      patientIndicatorNames: 'patientIndicatorNames/inventory',
    }),
  },
  methods: {
    ...mapActions({
      getInventory: 'patientIndicatorNames/inventory',
    })
  },
};
</script>
